import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { RetailerNodeEdge, RetailerNodeConnection } from '../../../schema';
import { retailerDropdown } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class RetailerDropdown extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<RetailerNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string }, { data: { allRetailers: RetailerNodeConnection } }>(
        API_URL,
        { name },
        retailerDropdown,
        HEADER,
        (v) => resolve(v.data.allRetailers.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      <AutoCompleteAsync
        {...this.props}
        mode='single'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<RetailerNodeEdge>, 'data'> {
  mode: 'single';
  value: RetailerNodeEdge;
  onChange: (value: RetailerNodeEdge) => void;
}
